import { useTranslation } from "react-i18next";

interface BtnResetProps {
    isDisabled: boolean;
    resetFn: () => void;
}

const BtnReset = (props: BtnResetProps) => {
    const { resetFn, isDisabled } = props;
    const { t } = useTranslation();

    return (
        <button
            className="py-2 px-4 text-sm !text-stone-darkest font-medium-light tracking-[-0.28px] !bg-transparent !rounded-lg"
            disabled={isDisabled}
            onClick={resetFn}
        >
            {t("searchForm.popup.btnUnselectAll")}
        </button>
    );
};

export default BtnReset;
